<template>
  <div class="login-page">
    <!-- 品牌展示区 -->
    <aside class="login-brand" aria-hidden="false">
      <div class="brand-inner">
        <div class="brand-logo">
          <img src="../assets/images/aptus-logo.png" alt="APTUS">
        </div>
        <p class="brand-tagline">智能综合力量训练 · 数据驱动运营</p>
        <ul class="brand-features">
          <li>
            <span class="feature-dot feature-dot--primary"></span>
            设备与用户实时管理
          </li>
          <li>
            <span class="feature-dot feature-dot--accent"></span>
            动作库与课程体系
          </li>
          <li>
            <span class="feature-dot feature-dot--primary"></span>
            训练计划与数据分析
          </li>
        </ul>
      </div>
      <!-- 力量曲线装饰 — 页面签名元素 -->
      <svg class="brand-curve" viewBox="0 0 400 200" preserveAspectRatio="none" aria-hidden="true">
        <path
          d="M0,180 C80,160 120,40 200,60 S320,140 400,20 L400,200 L0,200 Z"
          fill="url(#curveGradient)"
          opacity="0.12"
        />
        <path
          d="M0,160 Q100,80 200,100 T400,40"
          fill="none"
          stroke="url(#strokeGradient)"
          stroke-width="2.5"
          opacity="0.55"
        />
        <defs>
          <linearGradient id="curveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#2563EB" />
            <stop offset="100%" stop-color="#FF6F00" />
          </linearGradient>
          <linearGradient id="strokeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#3B82F6" />
            <stop offset="60%" stop-color="#FF6F00" />
            <stop offset="100%" stop-color="#FF8F3D" />
          </linearGradient>
        </defs>
      </svg>
    </aside>

    <!-- 登录表单区 -->
    <main class="login-main">
      <div class="login-card">
        <EnvironmentTag
          v-if="showEnvTag"
          class="login-env"
          :name="System_Name"
          variant="login"
        />

        <header class="login-header">
          <h2 class="login-heading">登录</h2>
          <p class="login-subheading">使用管理员账号进入后台</p>
        </header>

        <el-form
          class="login-form"
          :model="loginForm"
          :rules="loginFormRules"
          ref="loginForm"
          label-width="0px"
          @submit.native.prevent="submitForm"
        >
          <el-form-item label="" prop="username">
            <label class="field-label" for="login-username">账号</label>
            <el-input
              id="login-username"
              v-model="loginForm.username"
              prefix-icon="el-icon-user"
              placeholder="请输入账号"
              autocomplete="username"
            />
          </el-form-item>

          <el-form-item label="" prop="password">
            <label class="field-label" for="login-password">密码</label>
            <el-input
              id="login-password"
              type="password"
              v-model="loginForm.password"
              prefix-icon="el-icon-lock"
              placeholder="请输入密码"
              autocomplete="current-password"
              show-password
              @keyup.enter.native="submitForm"
            />
          </el-form-item>

          <el-form-item class="login-submit-item">
            <el-button
              type="primary"
              class="login-submit"
              :loading="submitting"
              @click="submitForm"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <footer class="login-footer">
        <span>APTUS 运动后台管理系统</span>
      </footer>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import EnvironmentTag from '../components/EnvironmentTag.vue'
Vue.use(VueAxios, axios)

export default {
  components: { EnvironmentTag },
  data () {
    return {
      System_Name: '',
      submitting: false,
      loginForm: {
        username: '',
        password: ''
      },
      loginFormRules: {
        username: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          },
          {
            min: 4,
            max: 20,
            message: '长度在 4 到 20 个字符',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            min: 4,
            max: 20,
            message: '长度在 4 到 20 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    showEnvTag () {
      // 登录页不显示环境标签，避免暴露部署信息
      return false
    }
  },
  mounted () {
    this.System_Name = Vue.prototype.global.System_Name
    this.CheckLoginStatus()
  },
  methods: {
    submitForm () {
      var that = this
      that.$refs.loginForm.validate((valid) => {
        if (valid) {
          that.Login()
        }
      })
    },
    Login: function () {
      var that = this
      that.submitting = true
      var data = {
        userLogin: that.loginForm.username,
        userPassword: that.loginForm.password
      }
      axios.post(Vue.prototype.global.Url_login, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.$notify.info({
              title: '提示',
              message: '登录成功',
              duration: 5000
            })
            localStorage.setItem('tempUuid', response.data.data.tempUuid)
            localStorage.setItem('userName', response.data.data.userName)
            localStorage.setItem('userAvatar', response.data.data.userAvatar)
            localStorage.setItem('authToken', response.data.data.authToken)
            localStorage.setItem('organizationType', response.data.data.organizationType)
            localStorage.setItem('organizationId', response.data.data.organizationId)
            localStorage.setItem('aptustwoGvListActionType', JSON.stringify(response.data.data.aptustwoGvListActionType))
            localStorage.setItem('aptustwoGvListBodyType', JSON.stringify(response.data.data.aptustwoGvListBodyType))
            localStorage.setItem('aptustwoGvListMuscleRoup', JSON.stringify(response.data.data.aptustwoGvListMuscleRoup))
            localStorage.setItem('aptustwoGvListAccessories', JSON.stringify(response.data.data.aptustwoGvListAccessories))
            localStorage.setItem('aptustwoGvListUseLocation', JSON.stringify(response.data.data.aptustwoGvListUseLocation))
            localStorage.setItem('aptustwoGvListCourseType', JSON.stringify(response.data.data.aptustwoGvListCourseType))
            localStorage.setItem('aptustwoGvListCourseDifficulty', JSON.stringify(response.data.data.aptustwoGvListCourseDifficulty))
            localStorage.setItem('aptustwoGvListCourseTimeType', JSON.stringify(response.data.data.aptustwoGvListCourseTimeType))
            localStorage.setItem('aptustwoGvListTrainPlanClassification', JSON.stringify(response.data.data.aptustwoGvListTrainPlanClassification))
            localStorage.setItem('aptustwoGvListTrainPlanType', JSON.stringify(response.data.data.aptustwoGvListTrainPlanType))
            localStorage.setItem('gvTypeList', response.data.data.gvTypeList)
            that.$router.push('/HomePage')
          }
        })
        .catch(function (error) {
          Vue.prototype.FunRemindNetWorkError(error)
        })
        .finally(function () {
          that.submitting = false
        })
    },
    CheckLoginStatus: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_checkLoginStatus, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.$router.push('/HomePage')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  min-height: 100vh;
  font-family: var(--font-family-base);
  background: var(--bg-page);
}

/* ---- 品牌面板 ---- */
.login-brand {
  position: relative;
  flex: 1 1 52%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-12) var(--space-10);
  background: linear-gradient(
    155deg,
    var(--bg-sidebar) 0%,
    color-mix(in srgb, var(--bg-sidebar) 80%, #1a3a6a) 45%,
    color-mix(in srgb, var(--bg-sidebar) 75%, #2a4a7a) 100%
  );
  overflow: hidden;
  color: var(--text-white);
}

.brand-inner {
  position: relative;
  z-index: 2;
  max-width: 420px;
  animation: brandFadeIn 600ms ease both;
}

.brand-logo {
  margin-bottom: var(--space-8);

  img {
    display: block;
    width: 168px;
    height: auto;
    object-fit: contain;
  }
}

.brand-tagline {
  font-size: var(--font-size-md);
  color: var(--text-sidebar);
  line-height: var(--line-height-normal);
  margin-bottom: var(--space-10);
}

.brand-features {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);

  li {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    font-size: var(--font-size-base);
    color: var(--text-sidebar);
    line-height: var(--line-height-normal);
  }
}

.feature-dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);

  &--primary {
    background: var(--color-primary-light);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-primary-light) 25%, transparent);
  }

  &--accent {
    background: var(--color-accent);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--color-accent) 22%, transparent);
  }
}

.brand-curve {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 38%;
  z-index: 1;
  pointer-events: none;
}

/* ---- 登录主区域 ---- */
.login-main {
  flex: 1 1 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-8) var(--space-6);
  min-width: 0;
}

.login-card {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding: var(--space-10) var(--space-8) var(--space-8);
  background: var(--bg-card);
  border: 1px solid var(--border-color-light);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  animation: cardSlideIn 500ms ease both;
  animation-delay: 120ms;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: var(--space-8);
    right: var(--space-8);
    height: 3px;
    border-radius: 0 0 var(--radius-sm) var(--radius-sm);
    background: linear-gradient(
      90deg,
      var(--color-primary) 0%,
      var(--color-primary-light) 55%,
      var(--color-accent) 100%
    );
  }
}

.login-env {
  position: absolute;
  top: 0;
  right: 0;
}

.login-header {
  margin-bottom: var(--space-8);
}

.login-heading {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  line-height: var(--line-height-tight);
  margin-bottom: var(--space-2);
}

.login-subheading {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  line-height: var(--line-height-normal);
}

.login-form {
  width: 100%;
}

.field-label {
  display: block;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
  margin-bottom: var(--space-2);
}

.login-submit-item {
  margin-top: var(--space-2);
  margin-bottom: 0;
}

.login-submit {
  width: 100%;
  height: 44px;
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  letter-spacing: 0.04em;
}

.login-footer {
  margin-top: var(--space-8);
  font-size: var(--font-size-xs);
  color: var(--text-tertiary);
  text-align: center;
}

/* ---- Element UI 局部覆盖 ---- */
.login-form ::v-deep .el-form-item {
  margin-bottom: var(--space-5);
}

.login-form ::v-deep .el-input__inner {
  height: 44px;
  line-height: 44px;
  font-size: var(--font-size-base);
}

.login-form ::v-deep .el-input__prefix {
  left: 12px;
}

.login-form ::v-deep .el-input--prefix .el-input__inner {
  padding-left: 38px;
}

.login-form ::v-deep .el-input__suffix {
  right: 12px;
}

.login-form ::v-deep .el-input__suffix-inner .el-input__icon {
  color: var(--text-tertiary);
  cursor: pointer;
  transition: color var(--transition-fast);

  &:hover {
    color: var(--color-primary);
  }
}

.login-form ::v-deep .el-form-item__error {
  font-size: var(--font-size-xs);
  padding-top: var(--space-1);
}

/* ---- 动效 ---- */
@keyframes brandFadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .brand-inner,
  .login-card {
    animation: none;
  }
}

/* ---- 响应式 ---- */
@media (max-width: 960px) {
  .login-page {
    flex-direction: column;
  }

  .login-brand {
    flex: none;
    padding: var(--space-8) var(--space-6) var(--space-10);
    min-height: auto;
  }

  .brand-inner {
    max-width: 100%;
  }

  .brand-logo img {
    width: 140px;
  }

  .brand-tagline {
    margin-bottom: var(--space-6);
    font-size: var(--font-size-base);
  }

  .brand-features {
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--space-3) var(--space-6);

    li {
      font-size: var(--font-size-sm);
    }
  }

  .brand-curve {
    height: 50%;
    opacity: 0.7;
  }

  .login-main {
    flex: 1;
    padding: var(--space-6);
    justify-content: flex-start;
  }

  .login-card {
    max-width: 440px;
    padding: var(--space-8) var(--space-6) var(--space-6);
  }
}

@media (max-width: 480px) {
  .brand-features {
    flex-direction: column;
    gap: var(--space-3);
  }

  .login-card {
    padding: var(--space-8) var(--space-5) var(--space-5);
    border-radius: var(--radius-lg);
  }
}
</style>
